import {Artist} from "./artist.utils";

export const ARTIST_LAUNCH_DATES: Record<Artist, Date> = {
  riize: new Date(process.env.REACT_APP_LAUNCH_DATE_RIIZE as string),
  aespa: new Date(process.env.REACT_APP_LAUNCH_DATE_AESPA as string),
};
